import { render, staticRenderFns } from "./Lgx266206193750376448.vue?vue&type=template&id=6ec72682&"
import script from "./Lgx266206193750376448.vue?vue&type=script&lang=js&"
export * from "./Lgx266206193750376448.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports